import React from 'react'

import cx from 'classnames'

import s from './input.module.scss'
import { InfoIcon } from '@/components/svg/info-icon/info-icon'

interface FloatingInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
  message?: string
  error?: string
  success?: string
  id: string
}

export default function Input({
  label,
  id,
  leftIcon,
  rightIcon,
  message,
  error,
  success,
  ...props
}: FloatingInputProps) {
  const errorId = `${id}-error`
  const messageId = `${id}-message`

  return (
    <div className={s.inputContainer}>
      <div
        className={cx(s.inputGroupContainer, {
          [s.disabled]: props.disabled,
          [s.error]: !!error,
          [s.success]: !!success,
        })}
      >
        {leftIcon && (
          <div className={cx(s.iconSlot, s.iconSlotLeft)}>{leftIcon}</div>
        )}

        <div className={s.fieldGroup}>
          <input
            {...props}
            id={id}
            suppressHydrationWarning
            onBlur={(e) => {
              props.onBlur?.(e)
            }}
            placeholder=" "
            aria-invalid={!!error}
            aria-describedby={
              error ? errorId : message || success ? messageId : undefined
            }
            className={s.input}
          />
          <label htmlFor={id} className={cx(s.label)}>
            {label}
          </label>
        </div>

        {rightIcon && (
          <div className={cx(s.iconSlot, s.iconSlotRight)}>{rightIcon}</div>
        )}
      </div>
      {error && (
        <div id={errorId} className={s.errorContainer} role="alert">
          <p>{error}</p>
        </div>
      )}
      {message && (
        <div id={messageId} className={s.messageContainer}>
          <InfoIcon />
          <p>{message}</p>
        </div>
      )}
      {success && (
        <div id={messageId} className={s.successContainer}>
          <p>{success}</p>
        </div>
      )}
    </div>
  )
}
